import '@/styles/components.scss'
import '@/styles/globals.scss'
import '@rainbow-me/rainbowkit/styles.css'

import { ChakraProvider } from '@chakra-ui/react'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Analytics } from '@vercel/analytics/next'
import { Host_Grotesk } from 'next/font/google'
import Head from 'next/head'
import NoSSR from 'react-no-ssr'
import { WagmiProvider } from 'wagmi'

import { ChakraFonts } from '@/common/components/CustomFont'
import { PageHead } from '@/common/components/PageHead'
import { config } from '@/config/wagmi'
import theme from '@/theme'

const NoS = NoSSR as any

const queryClient = new QueryClient()

const hostGrotesk = Host_Grotesk({
  display: 'swap',
  subsets: ['latin'],
  variable: '--font-host-grotesk',
  weight: ['400', '300', '500', '600', '700', '800'],
})

export const App = ({ Component, pageProps }) => {
  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout || ((page) => page)

  return (
    <NoS>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider showRecentTransactions>
            <ChakraProvider theme={theme}>
              <ChakraFonts />
              <Head>
                <meta
                  content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no, viewport-fit=cover"
                  name="viewport"
                />
                <PageHead />
              </Head>
              <main className={`h-full ${hostGrotesk.variable}`}>
                {getLayout(
                  <>
                    <Component {...pageProps} />
                    <Analytics />
                  </>,
                )}
              </main>
            </ChakraProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </NoS>
  )
}

export default App
